module.exports = __webpack_public_path__ + "img/7-itol-root-2.ee1982e4.png";